const emailIdeasForm = () => {
  const form = document.querySelector(".js-email-ideas");
  const openButtons = document.querySelectorAll(".js-open-email");

  if (form) {
    openButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        form.classList.add("hidden");
      });
    });
    const closeBtns = form.querySelectorAll(".js-close-ideas-form");

    closeBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        form.classList.remove("hidden");
      });
    });
  }
};

export default emailIdeasForm;
